const topics = [
  { name: '顶流塌房', heat: '982万', icon: 'ri-alert-line' },
  { name: '网红翻车', heat: '876万', icon: 'ri-emotion-sad-line' },
  { name: '综艺名场面', heat: '754万', icon: 'ri-tv-line' },
  { name: '恋情曝光', heat: '698万', icon: 'ri-heart-line' },
  { name: '影视争议', heat: '632万', icon: 'ri-film-line' },
  { name: '直播带货', heat: '521万', icon: 'ri-live-line' },
  { name: '小号被扒', heat: '489万', icon: 'ri-search-eye-line' },
  { name: '品牌解约', heat: '445万', icon: 'ri-hand-coin-line' },
  { name: '社交翻车', heat: '398万', icon: 'ri-emotion-unhappy-line' },
  { name: '明星穿搭', heat: '352万', icon: 'ri-t-shirt-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            全网热议话题标签，点击探索你感兴趣的吃瓜方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-background-200/60 rounded-full hover:border-accent-300/50 hover:bg-accent-50 transition-all cursor-pointer group"
            >
              <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className={`${topic.icon} text-sm text-accent-600 group-hover:text-accent-700 transition-colors`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
                {topic.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}